module.exports = __webpack_public_path__ + "img/notice-icon.84f6b0c0.svg";